/* hs-eslint ignored failing-rules */
/* eslint-disable react/prop-types */

'use es6';

import { forwardRef, useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { ThreadViewStoreSingleton } from '../../ThreadViewStoreSingleton';
import ThreadViewLifecycle from '../prop-types/ThreadViewLifecycle';
import ThreadViewManager from './ThreadViewManager';
import { DeletedMessagesContext } from '../../thread-deletion/context/DeletedMessagesContext';
import { AsyncComponentsContext } from '../context/AsyncComponentsContext';
import { ForwardingContext } from '../../unified-thread-history/context/ForwardingContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ThreadViewWrapper = /*#__PURE__*/forwardRef(({
  AsyncUIAvatar,
  auth,
  beaconTracker,
  children,
  disableForwarding,
  inboxId,
  lifecycle,
  omnibusData,
  showDeletedMessages,
  threadChannels,
  threadId,
  ticketCount,
  tracker,
  vid,
  visitor
}, ref) => {
  // initialize store singleton if it hasn't been
  ThreadViewStoreSingleton.init({
    auth,
    threadId,
    omnibusData
  });

  // delay mounting by one cycle to give the manager
  // a chance to sync state
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  const deletedMessagesContextValue = useMemo(() => ({
    showDeletedMessages
  }), [showDeletedMessages]);

  // while we support forwarding/reply with a pop-out communicator, we need this
  // escape hatch to hide forwarding/reply buttons in messages for the agent
  // thread view ui.
  const forwardingContextValue = useMemo(() => ({
    forwardingEnabled: !disableForwarding
  }), [disableForwarding]);
  const threadViewManagerProps = {
    beaconTracker,
    showDeletedMessages,
    inboxId,
    lifecycle,
    threadChannels,
    threadId,
    ticketCount,
    tracker,
    vid,
    visitor
  };
  // Render the thread view manager to interact with the
  // inner store (if it's in use) without overwriting the
  // children's redux context. Until everything migrated,
  // we also need to run the same behavior on the app-hosted
  // store as well
  return /*#__PURE__*/_jsx(AsyncComponentsContext.Provider, {
    value: {
      AsyncUIAvatar
    },
    children: /*#__PURE__*/_jsx(ForwardingContext.Provider, {
      value: forwardingContextValue,
      children: /*#__PURE__*/_jsxs(DeletedMessagesContext.Provider, {
        value: deletedMessagesContextValue,
        children: [/*#__PURE__*/_jsx(ThreadViewManager, Object.assign({}, threadViewManagerProps, {
          ref: ref
        })), mounted ? children : null]
      })
    })
  });
});
ThreadViewWrapper.displayName = 'ThreadViewWrapper';
ThreadViewWrapper.propTypes = {
  AsyncUIAvatar: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  beaconTracker: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  disableForwarding: PropTypes.bool.isRequired,
  lifecycle: ThreadViewLifecycle,
  showDeletedMessages: PropTypes.bool.isRequired,
  threadId: PropTypes.string.isRequired,
  ticketCount: PropTypes.number,
  tracker: PropTypes.object.isRequired,
  vid: PropTypes.number,
  visitor: PropTypes.object
};
ThreadViewWrapper.defaultProps = {
  auth: {},
  disableForwarding: false,
  showDeletedMessages: false,
  lifecycle: {}
};
export default ThreadViewWrapper;